import React, { Component } from 'react';
import { connect } from 'react-redux';
import { updateLivingSituation } from '../../../../actions/personalInfoAction';

import InlineEdit from '../../../../components/InlineEdit/InlineEdit';
import HousingStatusFields from '../../../../components/Fields/HousingStatusFields';
import StaticField from '../../../../components/StaticField/StaticField';
import SaveDialog from '../../../../components/SaveDialog/SaveDialog';

import {ADDRESS_HOUSINGSTATUS} from '../../../../utils/FieldTypes';

class InlineEditHousingStatus extends Component {
  constructor(props) {
    super(props);

    this.state = {
      edit: false,
      saveDialogOpen: false
    };
    this.setHousingStatus = this.setHousingStatus.bind(this);
    this.onClickSave = this.onClickSave.bind(this);
    this.toggleEdit = this.toggleEdit.bind(this);
    this.cancelEdit = this.cancelEdit.bind(this);
    this.toggleSaveDialog = this.toggleSaveDialog.bind(this);
  }
  setHousingStatus(event) {
    this.props.handleChange(ADDRESS_HOUSINGSTATUS, {target: {name: "housingStatus", value: event.target.name }});
  }
  validateField(event) {
    this.props.validateField(ADDRESS_HOUSINGSTATUS, event);
  }
  onClickSave(event) {
    event.preventDefault();
    this.props.validateFields(ADDRESS_HOUSINGSTATUS, ["housingStatus"], (isValid) => {
      if(isValid) {        
        this.props.updateLivingSituation(this.props.housingStatus, this.props.savedPersonalInfo.moveInDate);
        this.toggleEdit();
      }
      else {
        this.setState({
          saveDialogOpen: false
        })
      }
    });
  }
  toggleEdit() {    
    this.props.updateFieldsFromSavedState(ADDRESS_HOUSINGSTATUS);
    this.props.countOpenSections(!this.state.edit);
    this.setState({
      edit: !this.state.edit,
      saveDialogOpen: false
    });
  }
  cancelEdit() {
    if(this.props.housingStatus === this.props.savedPersonalInfo.housingStatus) {
      this.toggleEdit();
    }
    else {
      this.setState({
        saveDialogOpen: true
      })
    }
  }
  toggleSaveDialog() {
    this.setState({
      saveDialogOpen: !this.state.saveDialogOpen
    });
  }
  render() {
    let housingStatus = "";
    if(this.props.savedPersonalInfo.housingStatus === "rent") {
      housingStatus = "Rent";
    }
    else if(this.props.savedPersonalInfo.housingStatus === "own") {
      housingStatus = "Own";
    }
    else {
      housingStatus = "Other";
    }
    return (
      <div className="review-inline-edit">
        <StaticField label="Rent or own?" value={housingStatus} onClickEdit={this.toggleEdit} hidden={this.state.edit} disableEdit={this.props.sectionsOpen} />        
        <InlineEdit onClickSave={this.onClickSave} hidden={!this.state.edit} onClickCancel={this.cancelEdit}>  
          <HousingStatusFields {...this.props} setHousingStatus={this.setHousingStatus}   />
        </InlineEdit>
        <SaveDialog visible={this.state.saveDialogOpen} toggle={this.toggleSaveDialog} name="Address" onClickSave={this.onClickSave} onClickCancel={this.toggleEdit} />
      </div>);
  }
}

const mapStateToProps = state => ({
  //...state.personalInfo
});

const mapDispatchToProps = dispatch => ({
  updateLivingSituation: (housingStatus, moveInDate) => dispatch(updateLivingSituation(housingStatus, moveInDate))
});

export default connect(mapStateToProps, mapDispatchToProps)(InlineEditHousingStatus);


// WEBPACK FOOTER //
// ./src/containers/Review/InlineEdit/Address/HousingStatus.js